/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'object',
      properties: {
        type: {
          type: 'string',
        },
        geometry: {
          type: 'object',
          properties: {
            type: {
              type: 'string',
            },
            coordinates: {
              type: 'array',
              items: {
                type: 'number',
              },
            },
          },
          required: ['type', 'coordinates'],
        },
      },
      required: ['type', 'geometry'],
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    geojson: valueSchema,
  },
}
